import './style/JResultReward.scss';
import React from "react";
import { CMSSection } from "../models";
import { ResultRewardProp } from "./JResultGame";
import { JCMSImage } from '../JCMSImage';
import { JHTML } from '../JHTML';


export type ResultGameBodyProps = {
    resultRewards: ResultRewardProp[],
    pageConfig?: CMSSection,
}

export const JResultReward = ({ resultRewards, pageConfig }: ResultGameBodyProps) => {
    return (<>
            <div className={'result-reward-container'} >
                {!!resultRewards?.length && resultRewards?.map((resultReward: ResultRewardProp, index: number) => {
                    return (
                        <div className="reward-container" key={index}>
                            {!!resultReward?.images?.length &&
                            <div className="reward-image-container">
                                <div className="reward-image">
                                    <JCMSImage image={resultReward?.images || pageConfig?.image} />
                                </div>
                            </div>
                            }
                            {
                                resultRewards?.length > 1 && pageConfig?.title &&
                                <JHTML.Title html={resultReward?.title ? resultReward?.title : ''} />
                            }
                            {
                                resultRewards?.length === 1 && pageConfig?.title &&
                                <JHTML.Title html={pageConfig?.title + ' ' + ((resultRewards?.length === 1) ? resultReward?.title : '')} />
                            }
                            {
                                resultRewards?.length === 1 && pageConfig?.subTitle &&
                                <JHTML.SubTitle html={pageConfig?.subTitle} />
                            }
                            {
                                pageConfig?.text &&
                                <JHTML.Text html={pageConfig?.text} />
                            }
                        </div>
                    )
                })}
                {!resultRewards?.length &&
                <div className="reward-container">
                    <div className="reward-image-container lose">
                        <div className="reward-image">
                            <JCMSImage image={pageConfig?.image} />
                        </div>
                    </div>
                    {
                        pageConfig?.title &&
                        <JHTML.Title html={pageConfig?.title} />
                    }
                    {
                        pageConfig?.subTitle &&
                        <JHTML.SubTitle html={pageConfig?.subTitle} />
                    }
                    {
                        pageConfig?.text &&
                        <JHTML.Text html={pageConfig?.text} />
                    }
                </div>}
            </div>
        </>
    );
};
